module.exports = __webpack_public_path__ + "static/media/apostrophe.15fb7455.jpg";